<script>
  import { euroCouponsIssueMethods } from '@state/helpers'
  import JsonViewer from 'vue-json-viewer'
  
  export default {
    name: 'LogsPayless',
    components: {
      JsonViewer
    },
    props: {
      instanceJson: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      oncancel: {
        type: Function,
        required: false,
        default: () => ({}),
      },
    },
    data() {
      return {
        modalShow: true,
        loading: true,
        toDetail: {},
      }
    },
    computed: {},
  
    mounted: function () {
    },
  
    methods: {
    },
  }
  </script>
  
  <template>
    <b-modal
      v-model="modalShow"
      title="Detalle API Request"
      ok-only
      hide-footer
      @hidden="oncancel"
    >
      <b-container class="p-0">
        <b-row>
          <b-col  class="mx-auto" md="12">
            <b-card-group deck>
              <b-row>
                <b-card>
                  <json-viewer :value="instanceJson"
                    :expand-depth=5
                    copyable
                    sort></json-viewer>
                </b-card>
              </b-row>
            </b-card-group>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </template>
  <style lang="scss">
  </style>